import {
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_BEGIN,
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_SUCCESS,
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FAILURE,
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function loadExternalDatabase(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_BEGIN,
    });
    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}${args.version}/appwrites/${args.externalDbUuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_SUCCESS,
            data: res.data,
          });
          console.log('line no dddd', res);
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadExternalDatabaseError() {
  return {
    type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_BEGIN:
      return {
        ...state,
        loadExternalDatabasePending: true,
        loadExternalDatabaseError: null,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_SUCCESS:
      return {
        ...state,
        loadExternalDatabasePending: false,
        loadExternalDatabaseError: null,
        externalDatabase: action.data,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FAILURE:
      return {
        ...state,
        loadExternalDatabasePending: false,
        loadExternalDatabaseError: action.data.error,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_DISMISS_ERROR:
      return {
        ...state,
        loadExternalDatabaseError: null,
      };

    default:
      return state;
  }
}
